import { createStore } from '@stencil/store';

export const InitStore = createStore(<{ init: IWCInit }>{});
